import { useEffect, useState } from "react";
import Header from "../components/Header.js";
import BackButton from "../components/BackButton.js";
import Input from "../components/Input.js";
import Button from "../components/Button.js";
import GeneralService from "../services/general.service.js";
import ReactTable from "../components/ReactTable/ReactTable.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch, faExclamationTriangle, } from "@fortawesome/free-solid-svg-icons";

function useStationDirectoryPage() {
  const [stations, setStations] = useState([]);
  const [stationQueryFilter, setStationQueryFilter] = useState(undefined);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  // Filter
  const [stationName, setStationName] = useState("");

  function buildApiRequestParameters(filter) {
    if (filter === undefined) return undefined;
    if (!filter.stationName) return undefined;
    return { stationName: filter.stationName };
  }

  useEffect(() => {
    async function getStationData() {
      var requestParameters = buildApiRequestParameters(stationQueryFilter);

      var request = requestParameters === undefined
        ? GeneralService.getStations(page, pageSize)
        : GeneralService.stationsSearch(page, pageSize, requestParameters);

      setError(undefined);
      setIsLoading(true);

      await request
        .then((response) => {
          setPageSize(response.data.pageSize);
          setPage(response.data.pageNumber);
          setTotalPages(response.data.totalPages);
          setTotalElements(response.data.totalElements);

          // Map response DTO to our display model
          var mapped = response.data.results.map((d) => ({
            "name": d.name,
            "elr": d.elr,
            "mileage": Number(d.mileage).toFixed(4), // Always show 4 digits after the decimal point.
            "stationType": d.stationType,
            "owner": d.owner,
            "region": d.region
          }));

          setStations(mapped);
        })
        .catch((error) => {
          console.log(error);
          setError("An error occurred fetching the station directory.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    getStationData();
  }, [page, pageSize, stationQueryFilter])

  function submitQuery() {
    setPage(0);
    setStationQueryFilter({
      stationName: stationName
    });
  };

  function resetFilter() {
    setStationName("");
  }

  return {
    submitQuery, resetFilter, stationName, setStationName, isLoading, error, stations, page, pageSize, totalElements, totalPages, setPageSize, setPage
  }
}

function StationDirectoryPage() {
  const { submitQuery, resetFilter, stationName, setStationName, isLoading, error, stations, page, pageSize, totalElements, totalPages, setPageSize, setPage } = useStationDirectoryPage();

  function handleResetClick(e) {
    e.preventDefault();
    resetFilter();
  }
  function handleSubmitClick(e) {
    e.preventDefault();
    submitQuery();
  }

  return (
    <div className="page" id="stationDirectoryPage">
      <Header title="Station Directory" />
      <BackButton navigateUrl="/generalinfo" />

      <div className="search-form">

        <div className="search-form__section">
          <h3>Search Station Directory</h3>
          <Input
            name="search"
            label="Search"
            value={stationName}
            onChange={e => setStationName(e.target.value)}
          />
        </div>

        {isLoading && (
          <div className="loadingCircle">
            <FontAwesomeIcon icon={faCircleNotch} spin={true} />
          </div>
        )}

        {error !== undefined && (
          <div className="loadingCircle">
            <FontAwesomeIcon icon={faExclamationTriangle} /> Error fetching data
          </div>
        )}

        {!isLoading && error === undefined && stations && (
          <ReactTable
            tableData={stations}
            currentPage={page}
            totalPages={totalPages}
            pageSize={pageSize}
            totalElements={totalElements}
            setPage={setPage}
            setPageSize={setPageSize}
          />
        )}

        <div className="button-group search-form__submit">
          <Button action="secondary" label="Reset" onClick={handleResetClick} />
          <Button action="primary" label="Search" onClick={handleSubmitClick} />
        </div>
      </div>
    </div>
  );
}

export default StationDirectoryPage;
